module.exports = __webpack_public_path__ + "static/img/07054B_2_3_R_20200527_LC.9e67b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07054B_2_3_R_20200527_LC.png
// module id = ILid
// module chunks = 0